export const GOJS_INSPECTOR_PROPERTIES = {
    angle: "Angle",
    color: "Color",
    description: "Description",
    forward: "Relationship Forward",
    from: "From",
    height: "Height",
    id: "ID",
    isDeleted: "Is deleted",
    key: "Key",
    location: "Location",
    name: "Type Name",
    relationship_name: "Relationship Name",
    reverse: "Reverse Relationship",
    routing: "Routing",
    shape: "Shape",
    to: "To",
    visible: "Visible",
    width: "Width",
    fontColor: "Text color",
    systemRequired: "System Required",
    points: "Points"
};

export const GOJS_SELECT_CHOICES = {
    //true/false
    true: "true",
    false: "false",
    //link routing
    Normal: "Normal",
    Orthogonal: "Orthogonal",
    AvoidsNodes: "Avoids Nodes",
    //shapes
    Actor: "Person",
    Beaker: "Beaker",
    BoatShipment: "Boat",
    BpmnEventTimer: "Clock",
    Building: "Building",
    Card: "Card",
    Circle: "Circle",
    CircleLine: "Circle Line",
    Cloud: "Cloud",
    Club: "Club",
    Component: "Component",
    Cone1: "Cone 1",
    Cone2: "Cone 2",
    Crescent: "Crescent",
    Cube1: "Cube 1",
    Cube2: "Cube 2",
    Cylinder1: "Cylinder 1",
    Cylinder2: "Cylinder 2",
    Cylinder3: "Cylinder 3",
    Cylinder4: "Cylinder 4",
    Decagon: "Decagon",
    Diamond: "Diamond",
    Dodecagon: "Dodecagon",
    Drink: "Full glass",
    EightPointedBurst: "Eight-pointed Burst",
    EightPointedStar: "Eight-pointed Star",
    Ellipse: "Ellipse",
    Email: "Email",
    EmptyDrink: "Empty glass",
    Flag: "Flag",
    FireHazard: "Fire",
    FivePointedBurst: "Five-pointed Burst",
    FivePointedStar: "Five-pointed Star",
    FramedRectangle: "Framed Rectangle",
    Gear: "Gear",
    HalfEllipse: "Half Ellipse",
    Hand: "Hand",
    Heart: "Heart",
    Heptagon: "Heptagon",
    Hexagon: "Hexagon",
    HourGlass: "Hour Glass",
    Key: "Key",
    Location: "Location",
    Lock: "Locked",
    Map: "Map",
    NinePointedBurst: "Nine-pointed Burst",
    NinePointedStar: "Nine-pointed Star",
    Nonagon: "Nonagon",
    Octagon: "Octagon",
    Parallelogram1: "Parallelogram 1",
    Parallelogram2: "Parallelogram 2",
    Pentagon: "Pentagon",
    Pie: "Pie",
    PiePiece: "Pie Piece",
    Plane: "Plane",
    Prism1: "Prism 1",
    Prism2: "Prism 2",
    Pyramid1: "Pyramid 1",
    Pyramid2: "Pyramid 2",
    Rectangle: "Rectangle",
    RightTriangle: "Right Triangle",
    Ring: "Ring",
    RoundedIBeam: "Rounded I Beam",
    RoundedRectangle: "Rounded Rectangle",
    SevenPointedBurst: "Seven-pointed Burst",
    SevenPointedStar: "Seven-pointed Star",
    SixPointedBurst: "Six-pointed Burst",
    SixPointedStar: "Six-pointed Star",
    Spade: "Spade",
    SpeechBubble: "Speech Bubble",
    Square: "Square",
    SquareArrow: "Square Arrow",
    TenPointedBurst: "Ten-pointed Burst",
    TenPointedStar: "Ten-pointed Star",
    ThickCross: "Thick Cross",
    ThickX: "Thick X",
    Trapezoid: "Trapezoid",
    TriangleDown: "Triangle Down",
    TriangleLeft: "Triangle Left",
    TriangleRight: "Triangle Right",
    TriangleUp: "Triangle Up",
    TruckShipment: "Truck",
    Unlocked: "Unlocked",
    Warehouse: "Warehouse"
};

export const LAYOUT_OBJECT_TYPES = {
    BO: "Business object",
    REL: "Relationship"
};

export const LAYOUT_OBJECT_STATES = {
    hidden: "hidden",
    created: "created"
};

export const LAYOUT_ATRRIBUTES = {
    relTypes: "Relation types",
    numberOfLayers: "Number of layers",
    name: "Name",
    nodes: "Nodes",
    links: "Links",
    instanceId: "Instance ID",
    maxRelPerRelType: "Max relationships per rel type"
};

export const LAYOUT_CONST = {
    layout: "Instance Relationship Diagram"
};

export const EVENTS = {
    boView: {
        typesGrid: {
            open: "types-grid:open",
            create: "types-grid:create",
            update: "types-grid:update",
            delete: "types-grid:delete"
        },
        attributesGrid: {
            open: "attributes-grid:open",
            create: "attributes-grid:create",
            update: "attributes-grid:update",
            delete: "attributes-grid:delete"
        },
        relationshipsGrid: {
            open: "relationships-grid:open",
            create: "relationships-grid:create",
            update: "relationships-grid:update",
            delete: "relationships-grid:delete"
        },
        valueListGrid: {
            open: "value-list-grid:open",
            create: "value-list-grid:create",
            update: "value-list-grid:update",
            delete: "value-list-grid:delete"
        },
        objectsLayout: {
            open: "layout:open",
            saveObjects: "layout:saveObjects",
            hidden: "layout:hidden",
            create: "layout:create",
            update: "layout:update",
            delete: "layout:delete",
            fetchAll: "layout:fetchAll"
        },
        setBusinessObject: "bo-view:set-business-object",
        setAttribute: "bo-view:set-attribute-object",
        setRelationship: "bo-view:set-relationship-object",
        setAttributeValue: "bo-view:set-attribute-value-object"
    },
    boInstance: {
        editInstance: {
            open: "editInstance:open"
        },
        instanceLayout: {
            open: "instanceLayout:open",
            filter: "instanceLayout:filter",
            changeRelColor: "instanceLayout:changeRelColor",
            changeRelPattern: "instanceLayout:changeRelPattern",
            changeNumberOfLayers: "instanceLayout:changeNumberOfLayers",
            updatePageForRelation: "instanceLayout:updatePageForRelation",
            selectLayout: "instanceLayout:selectLayout",
            createLayout: "instanceLayout:createLayout",
            updateLayout: "instanceLayout:updateLayout",
            deleteLayout: "instanceLayout:deleteLayout"
        }
    },
    dataViewConfiguration: {
        openColumnsGrid: "data-view:open-columns-grid",
        setCurrentDataView: "data-view:set-current-data-view",
        createDataView: "data-view-configuration:create",
        updateDataView: "data-view-configuration:update",
        deleteDataView: "data-view-configuration:delete",
        updateDataViewColumns: "data-view-configuration-columns:update"
    },
    editForm: {
        setCurrentInstance: "edit-form:setCurrentInstance",
        setNewInstance: "edit-form:setNewInstance",
        updateInstanceTags: "edit-form:update-instance-tags",
        addRelationshipGrid: {
            setCurrentDataView: "edit-form-add-relationships-grid:set-current-data-view",
        },
        fileAttachedGrid: {
            uploadProgress: "edit-form:upload-progress",
            updateFileDictionary: "edit-form:update-file-dictionary"
        },
        addInstanceRelationship: "edit-form:add-instance-relationship",
        deleteInstanceRelationship: "edit-form:delete-instance-relationship",
        changeUpdateKey: "edit-form:change-update-key"
    },
    partsToCompare: {
        compare: "parts-to-compare:compare"
    }
};



// WEBPACK FOOTER //
// ./app/config/boCore.ts